import React, { useEffect, useState } from "react";
import { ShieldCheck, FileText } from "lucide-react";
import { toast } from "sonner";
import client, { errText } from "@/lib/api";

const STATUSES = [
  { k: "pending", label: "قيد الانتظار", color: "var(--k-ink-soft)" },
  { k: "under_review", label: "قيد المراجعة", color: "#B8860B" },
  { k: "docs_required", label: "مستندات إضافية", color: "#C77800" },
  { k: "verified", label: "موثّق", color: "var(--k-emerald)" },
  { k: "rejected", label: "مرفوض", color: "var(--k-ruby)" },
  { k: "suspended", label: "موقوف", color: "var(--k-ruby)" },
];

export default function AdminVerification() {
  const [filter, setFilter] = useState("all");
  const [list, setList] = useState([]);
  const [notes, setNotes] = useState({});

  const load = () => client.get(`/admin/verification${filter !== "all" ? `?status=${filter}` : ""}`).then((r) => setList(r.data)).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

  const act = async (mid, status) => {
    try {
      await client.put(`/admin/verification/${mid}`, { status, note: notes[mid] || "" });
      toast.success("تم تحديث حالة التوثيق وإشعار التاجر");
      load();
    } catch (e) { toast.error(errText(e)); }
  };

  return (
    <div dir="rtl">
      <h2 className="font-head text-[16px] font-bold px-4 pt-5 pb-2 flex items-center gap-1.5"><ShieldCheck size={17} style={{ color: "var(--k-gold-deep)" }} /> التوثيق ({list.length})</h2>
      <div className="px-4 pb-2 flex gap-1.5 flex-wrap">
        {[{ k: "all", label: "الكل" }, ...STATUSES].map((s) => (
          <button key={s.k} data-testid={`verify-filter-${s.k}`} onClick={() => setFilter(s.k)} className="k-tap px-3 py-1.5 rounded-full text-[12px] font-bold" style={{ background: filter === s.k ? "var(--k-ink)" : "var(--k-paper)", color: filter === s.k ? "#fff" : "var(--k-ink)", border: "1px solid var(--k-line)" }}>{s.label}</button>
        ))}
      </div>
      <div className="px-4 pb-6 space-y-3">
        {list.length === 0 && <p className="text-[13px]" style={{ color: "var(--k-ink-soft)" }}>لا توجد طلبات</p>}
        {list.map((m) => {
          const st = STATUSES.find((x) => x.k === m.status) || STATUSES[0];
          return (
            <div key={m.id} data-testid={`verify-card-${m.id}`} className="rounded-2xl p-4" style={{ background: "var(--k-surface)", border: "1px solid var(--k-line)" }}>
              <div className="flex items-center justify-between gap-2 mb-1">
                <span className="font-bold text-[14px]">{m.name}</span>
                <span className="text-[11px] font-bold px-2.5 py-1 rounded-full" style={{ background: "var(--k-paper)", color: st.color, border: `1px solid ${st.color}` }}>{st.label}</span>
              </div>
              <div className="text-[12px] mb-2" style={{ color: "var(--k-ink-soft)" }}>{m.city} · {m.cat} · {m.phone}</div>
              <div className="flex items-center gap-1.5 text-[11px] mb-2" style={{ color: "var(--k-ink-soft)" }}><FileText size={13} /> المستندات: {(m.documents && m.documents.length) ? `${m.documents.length} مرفق` : "لا توجد مستندات مرفوعة"}</div>
              <textarea data-testid={`verify-note-${m.id}`} defaultValue={m.internal_note || ""} onChange={(e) => setNotes((n) => ({ ...n, [m.id]: e.target.value }))} placeholder="ملاحظة داخلية (لا تُرسل للتاجر)" rows={2} className="w-full rounded-xl px-3 py-2 text-[12px] mb-2" style={{ background: "var(--k-paper)", border: "1px solid var(--k-line)" }} />
              <div className="flex flex-wrap gap-1.5">
                {STATUSES.filter((s) => s.k !== m.status).map((s) => (
                  <button key={s.k} data-testid={`verify-set-${m.id}-${s.k}`} onClick={() => act(m.id, s.k)} className="k-tap px-2.5 py-1.5 rounded-lg text-[11.5px] font-bold" style={{ background: "var(--k-paper)", color: s.color, border: `1px solid ${s.color}` }}>{s.label}</button>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
